// extracted by mini-css-extract-plugin
export default {"recipient":"SendPurchaseOrderSmsModal_recipient__UGslC","recipientHeader":"SendPurchaseOrderSmsModal_recipientHeader__2Aokk"};